export default (hierarchy, value, key = 'id') => {
    let positon = { cIndex: -1, sIndex: -1, pIndex: -1 };

    const find = (array) => {
        if (!array) return;

        let inner,
            index = array.findIndex((o, i) => {
                if (o[key] === value) return true;
                if (Array.isArray(o.children)) return inner = find(o.children);

            })

        return index !== -1 && [index, ...(inner || [])];

    }

    let result = find(hierarchy);

    positon.cIndex = result[0] > -1 ? result[0] : positon.cIndex;
    positon.sIndex = result[1] > -1 ? result[1] : positon.sIndex;
    positon.pIndex = result[2] > -1 ? result[2] : positon.pIndex;

    return positon;
};
